import Vue from 'vue';
import { trackException } from '@/tracking/applicationinsights';
Vue.config.ignoredElements = ['ai-agent-float'];
Vue.config.errorHandler = function errorHandler(err, vm, info) {
    trackException(err, {
        component: vm?.$vnode?.tag || '',
        info,
    });
};
